export function isRunning(status) {
    return (
        status === 10 || status === 11 || status === 20 || status === 21 ||
        status === 30 || status === 31
    );
}